
import { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const lastStatus = useRef(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      if (lastStatus.current === false) toast.success("You are back online");
      setIsOnline(true);
      lastStatus.current = true;
    };

    const handleOffline = () => {
      if (lastStatus.current === true) toast.error("You are offline");
      setIsOnline(false);
      lastStatus.current = false;
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline;
}
